/**
 * Applies nofollow to external links across the page after render and on navigation.
 */

import { useEffect } from "react";
import { useRouter } from "next/router";
import { processExternalLinks } from "helpers/linkUtils";

const ExternalLinkHandler = () => {
  const router = useRouter();

  useEffect(() => {
    let debounceTimer;

    const run = () => {
      processExternalLinks(document.body);
    };

    const debouncedRun = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(run, 50);
    };

    run();

    const observer = new MutationObserver(debouncedRun);

    observer.observe(document.body, {childList: true, subtree: true});

    router.events.on("routeChangeComplete", run);

    return () => {
      clearTimeout(debounceTimer);
      observer.disconnect();
      router.events.off("routeChangeComplete", run);
    };
  }, [router.events]);

  return null;
};

export default ExternalLinkHandler;
